import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/SeeAllGrid.css";

const SeeAllGrid = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const videos = location.state?.videos || [];

  // Track screen size for conditional rendering
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update isMobile on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleVideoClick = (videoUrl) => {
    // Extract the part after `watch?v=` but before any & for playlist
    let videoId = videoUrl.includes("watch?v=")
      ? videoUrl.split("watch?v=")[1].split("&")[0]
      : null;

    // Check for a possible playlist
    const urlParams = new URLSearchParams(
      videoUrl.substring(videoUrl.indexOf("?") + 1)
    );
    const playlistId = urlParams.get("list");

    if (playlistId && videoId) {
      navigate(`/watch/${videoId}?list=${playlistId}`);
    } else if (videoId) {
      navigate(`/watch/${videoId}`);
    } else {
      console.warn("Could not parse videoId from URL:", videoUrl);
    }
  };

  // =============================
  //  Mobile Layout (Unchanged)
  // =============================
  const renderMobile = () => (
    <div className="see-all-container">
      {/* Header with "Go Back" and "All Videos" text centered */}
      <div className="header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <img
            src="/static/images/arrowLeftSymbol.png"
            alt="Back"
            className="arrow-left-symbol"
          />
        </button>
        <h1 className="section-title">Title Section 1</h1>
      </div>

      <div className="see-all-video-grid">
        {videos.map((video) => (
          <div
            key={video.id}
            className="see-all-grid-video"
            onClick={() => handleVideoClick(video.id)}
          >
            <div className="thumbnail-container">
              <img
                src={video.thumbnail}
                alt={video.title}
                className="video-thumbnail"
              />
              <img
                src="/static/images/playSymbol.png"
                alt="Play"
                className="play-icon"
              />
            </div>
            <h3 className="video-all-title">{video.title}</h3>
            <p className="video-duration">{video.duration}</p>
          </div>
        ))}
      </div>
    </div>
  );

  // =============================
  //  Desktop Layout (New)
  // =============================
  const renderDesktop = () => (
    <div className="see-all-container-desktop">
      {/* Header with "Go Back" and "Title Section 1" in center */}
      <div className="header-desktop">
        <button className="back-button-desktop" onClick={() => navigate(-1)}>
          <img
            src="/static/images/arrowLeftSymbol.png"
            alt="Back"
            className="arrow-left-symbol"
          />
        </button>
        <h1 className="section-title-desktop">Title Section 1</h1>
      </div>

      <div className="see-all-video-grid-desktop">
        {videos.map((video) => (
          <div
            key={video.id}
            className="see-all-grid-video-desktop"
            onClick={() => handleVideoClick(video.id)}
          >
            <div className="thumbnail-container-desktop">
              <img
                src={video.thumbnail}
                alt={video.title}
                className="video-thumbnail-desktop"
              />
              <img
                src="/static/images/playSymbol.png"
                alt="Play"
                className="play-icon-desktop"
              />
            </div>
            <h3 className="video-all-title-desktop">{video.title}</h3>
            <p className="video-duration-desktop">{video.duration}</p>
          </div>
        ))}
      </div>
    </div>
  );

  // Render mobile or desktop depending on isMobile
  return isMobile ? renderMobile() : renderDesktop();
};

export default SeeAllGrid;
